export default {
    wallet: 'កាបូប',
    balance: 'តុល្យភាព',
    wallet_transaction: 'ប្រតិបត្តិការកាបូប',
    top_up: 'បញ្ចូល​លុយ',
    withdraw: 'ដកលុយ',
    withdraw_refund: 'ដកប្រាក់មកវិញ',
    invoice: 'វិក្ក័យប័ត្រ',
    invoice_refund: 'សងប្រាក់វិក្ក័យប័ត្រ',
    manual_refund: 'ការសងប្រាក់វិញធម្មតា',
    sms_service: 'សេវា SMS',
    id: 'លេខសម្គាល់',
    time: 'ពេលវេលា',
    type: 'ប្រភេទ',
    amount: 'ចំនួនទឹកប្រាក់',
    action: 'សកម្មភាព',
    detail: 'លម្អិត',
    amount_from: 'ចំនួនទឹកប្រាក់ពី',
    status: 'ស្ថានភាព',
    pending: 'Pending',
    processing: 'Processing',
    paid: 'Paid',
    complete: 'Complete',
    cancelled: 'Cancelled',
    account_balance: 'សមតុល្យ​គណនី',
    method: 'ការទូទាត់',
    manual_refund_detail: 'ព័ត៌មានលម្អិតអំពីការសងដោយដៃ',
    payments: 'ការទូទាត់',
    wallet_detail: 'ពត៌មានលម្អិតក្នុងការបញ្ចូលទឹកប្រាក់',
};
